function Battery({ width, height}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 54 30"
    >
      <path
        fill="#fff"
        d="M42-12H9v-12h33zM0-25.5A7.5 7.5 0 017.5-33h36a7.5 7.5 0 017.5 7.5v1.5a3 3 0 013 3v6a3 3 0 01-3 3v1.5A7.5 7.5 0 0143.5-3h-36A7.5 7.5 0 010-10.5zm7.5-3a3 3 0 00-3 3v15a3 3 0 003 3h36a3 3 0 003-3v-15a3 3 0 00-3-3z"
        data-name="Path 2248"
        transform="translate(0 33)"
      ></path>
    </svg>
  );
}

export default Battery;
